import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserResponseDto } from '../../schemas/users/user-response.dto';
import { AUTH_BASE_URL } from '../../auth-base-url.token';
import { CreateUserRequestDto } from '../../schemas/users/create-user-request.dto';
import { ChangePasswordRequestDto } from '../../schemas/users/change-password-request.dto';
import { PasswordResetResponseDto } from '../../schemas/users/password-reset-response.dto';
import { CurrentUserInfoDto } from '../../schemas/users/current-user-info.dto';
import { ChangePasswordResponseDto } from '../../schemas/users/change-password-response.dto';
import { UserCreatedResponseDto } from '../../schemas/users/user-created-response.dto';
import { UserUpdatedResponseDto } from '../../schemas/users/user-updated-response.dto';
import { UserDeletedResponseDto } from '../../schemas/users/user-deleted-response.dto';
import { SetNewPasswordRequestDto } from '../../schemas/users/set-new-password-request.dto';

@Injectable({ providedIn: 'root' })
export class UsersApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(AUTH_BASE_URL)}/users`;

    getUsersByOrganization(organizationId: number) {
        return this.builder
            .url(`${this.controllerUrl}/byOrganization/${organizationId}`)
            .get()
            .json<UserResponseDto[]>()
            .build()
            .send();
    }

    create(payload: CreateUserRequestDto) {
        return this.builder
            .url(this.controllerUrl)
            .post(payload)
            .json<UserCreatedResponseDto>()
            .build()
            .send();
    }

    update(payload: CreateUserRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/${payload.id}`)
            .put(payload)
            .json<UserUpdatedResponseDto>()
            .build()
            .send();
    }

    delete(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/${id}`)
            .delete()
            .json<UserDeletedResponseDto>()
            .build()
            .send();
    }

    resetPassword(id: number) {
        return this.builder
            .url(`${this.controllerUrl}/${id}/reset-password`)
            .post(null)
            .json<PasswordResetResponseDto>()
            .build()
            .send();
    }

    changePassword(payload: ChangePasswordRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/change-password`)
            .post(payload)
            .json<ChangePasswordResponseDto>()
            .build()
            .send();
    }

    setNewPassword(payload: SetNewPasswordRequestDto) {
        return this.builder
            .url(`${this.controllerUrl}/set-new-password`)
            .post(payload)
            .json<ChangePasswordResponseDto>()
            .build()
            .send();
    }

    me() {
        return this.builder
            .url(`${this.controllerUrl}/me`)
            .get()
            .json<CurrentUserInfoDto>()
            .build()
            .send()
    }
}
